import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
//import { GAME_STATE_INIT, GAME_STATE_ACTIVE, GAME_STATE_RESULTS, HOST_STATE_GROUP_SELECT, HOST_STATE_GROUP, HOST_STATE_MAIN,
//    HOST_STATE_RESULTS, GROUP_STATE_INIT, GROUP_STATE_ACTIVE, GROUP_STATE_RESULTS } from '../../../../store/actions/gameActions';
import {
    hasGameControl,
    getUserGroup_hc,
    determineHost
  } from '../../game_functions/functions';
  import Avatar from '@material-ui/core/Avatar';
//import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import ListItemIcon from '@material-ui/core/ListItemIcon';
//import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import { deepDiffMapper } from '../../game_functions/functions';
import { moveBackToResultsPhase, moveBackToActiveWithParams, moveBackToInitPhaseWithOption, updateResultsPath, updateGameStateParams  } from '../../../../../store/actions/gameActions';
import Typography from '@material-ui/core/Typography';
import styles from '../../../../Styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import PermMediaIcon from '@material-ui/icons/PermMedia';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';


import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AddIcon from '@material-ui/icons/Add';
import ChangeHistoryIcon from '@material-ui/icons/ChangeHistory';

//import { wordGroups } from './../data/data';
import DebriefChart from './../specific_components/debriefChart.js';
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import Paper from '@material-ui/core/Paper';
import ForwardIcon from '@material-ui/icons/Forward';
import { gameHasOptions, gameOptions } from './../../../gameServer';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`nav-tabpanel-${index}`}
        aria-labelledby={`nav-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  
  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

const INITIAL_STATE = {
    open: false,    
    tab: 0,
};

class GameResults extends Component {

    constructor(props) {
        super(props);
        

        this.state = {
          ...INITIAL_STATE,
        };
    }

    handleTabChange = (event, newValue) => {
        console.log('????', event, newValue);
        this.setState({
          ...this.state,
          tab: newValue
        })
    };

    render() {
    const {
      session,
      classes,
      auth,
      profile,
      game_options
      //game_id, game_title,  profile, auth, group_state, game_state
    } = this.props;


        return (
        <div ref={this.mainDiv}>
            <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>




                <Typography variant="h3">{session.active_game.name}</Typography>
                <Typography variant='h5' className={classes.spaceBottom}>
                    Debrief
                </Typography>

          
                { /*: null */ }
            </Grid>
            <Grid item xs={12} sm={12} ref={this.gridLeft}>
                    <Paper square className={classes.root}  style={{minHeight: "700px", minWidth: "920px"}}>
                        <AppBar position="static">
                        <Tabs
                        value={this.state.tab}
                        onChange={this.handleTabChange}
                        variant="fullWidth"
                        indicatorColor="secondary"
                        
                        aria-label="icon label tabs example"
                        >
                        { Object.keys(session.groups).sort().map((groupKey, ind) => {
                            if ( groupKey !== 'group-0' ){
                                return (
                                    <Tab label={session.groups[groupKey].title} key={ind-1} />
                                )
                            } else {
                                return null;
                            }
                        })}
                    
                        </Tabs>
                        </AppBar>
                        { Object.keys(session.groups).sort().map((groupKey, ind) => {
                          if ( groupKey === 'group-0' ){
                            return null
                          }
                        
                          let history = this.props.session.active_game.results[groupKey] !== undefined ?
                          this.props.session.active_game.results[groupKey].choiceHistory === undefined ? [] : this.props.session.active_game.results[groupKey].choiceHistory
                          : [];
                         return (
                          <TabPanel value={this.state.tab} index={ind-1} key={ind-1} >
                            <div className={classes.spacingTop}>
                                <DebriefChart 
                                    history={history} 
                                    onlyCurrentRun={false} 
                                    debrief={true}
                                    classes={this.props.classes} 
                                    session={this.props.session} 
                                    profile={this.props.profile} 
                                    auth={this.props.auth} 
                                    group_id={groupKey}
                                    hasControl={false}
                                />
                                
                            </div>
                            
                          </TabPanel>
                         )                           
                        })}                    
                    </Paper>


                   
            </Grid>
            
            </Grid>
        </div>
        );
    
  }
}

const mapStateToProps = (state) => {
  //console.log('this is my state', state);
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
   
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(GameResults);
